module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3c20092903063da1188ed242f2ce318c.gif";